import { b as b2cSiteTypeURLPrefix, s as siteType, L as LOCALE_CODE_REGEX } from './request.constants-deb285e0.js';
import { s as send, e as refinementStateChangedEvent, O as ONLINE_CTA_TYPES } from './send-33ade633.js';
import { _ as __rest } from './tslib.es6-2af8cb53.js';
import { B as Build } from './index-16dc7dde.js';
import { c as createCommonjsModule, a as commonjsGlobal } from './_commonjsHelpers-ba3f0406.js';
import { i as isV3 } from './lookups-705fb53e.js';
import { _ as _isIndex } from './_isIndex-af307327.js';
import { t as toNumber_1 } from './toNumber-5000b45d.js';
import { f as format$1 } from './currency-b61904e0.js';
import { p as parseRecords } from './parsers-e38ff6a5.js';

const OFFSET_PARAM_NAME = 'No';
const PRODUCTS_PER_PAGE_PARAM_NAME = 'Nrpp';
const NAVIGATION_STATE_PARAM_NAME = 'N';
const BUSINESS_ID_PARAM_NAME = 'businessId';
const SELECTED_NODE_ID = 'selected-node-id';
const DEFAULT_NAVIGATION_STATE = '726se132';

const productCtasColors = {
    PRIMARY_BLUE: 'primaryBlue',
    SECONDARY_BLUE: 'secondaryBlue',
    PRIMARY_GREEN: 'primaryGreen',
    SECONDARY_GREEN: 'secondaryGreen',
};
const MAX_CTA_LIMIT = 3;
const ADDITIONAL_CTA_LINKS = 'addition-links';
const NUMBER_OF_BUTTONS_BEFORE = 3;
const productCtasButtonType = {
    CART: 'cart',
    FAVORITES: 'favorites',
    COMPARE: 'compare',
};
const productCtas = {
    buttons: {
        [productCtasButtonType.CART]: {
            isShown: true,
            list: [],
            color: productCtasColors.PRIMARY_BLUE,
            icons: {
                addIcon: 'segment_retail',
                disableIconInPdpCtaBlock: true,
            },
            dataset: {
                daElementId: 'add_p',
            },
            labels: {},
        },
        [productCtasButtonType.FAVORITES]: {
            isShown: false,
            list: [],
            color: productCtasColors.SECONDARY_BLUE,
            icons: {
                addIcon: 'star_stroke',
                removeIcon: 'star_plain',
            },
            dataset: {
                daElementId: 'add_p',
            },
            labels: {},
        },
    },
    productProp: 'repositoryId',
};

const processGlobalAnalyticsEvent = (originalEvent, extraParams) => {
    originalEvent.stopPropagation();
    const { event } = originalEvent.detail;
    switch (event) {
        case 'refinementStateChanged': {
            const { isChecked } = originalEvent.detail;
            send(refinementStateChangedEvent, Object.assign({ isChecked }, extraParams));
            break;
        }
    }
};

const name = "@pes-ui/components";
const version = "3.84.0";
const description = "PES Components";
const main = "dist/index.js";
const module = "dist/index.mjs";
const es2015 = "dist/esm/index.mjs";
const es2017 = "dist/esm/index.mjs";
const types = "dist/types/index.d.ts";
const collection = "dist/collection/collection-manifest.json";
const unpkg = "dist/components/components.js";
const files = [
	"dist/",
	"loader/",
	"src/"
];
const scripts = {
	build: "npm run build:prod",
	"build:docs:storybook": "npm run pre-start && stencil build --docs --dev && npm run fix-readme && npm run storybook:build",
	"build:prod": "cross-env NODE_ENV=production npm run pre-start && stencil build --docs --prerender && npm run fix-readme",
	"build:docs": "npm run pre-start && stencil build --docs --dev && npm run fix-readme",
	"build:dev": "npm run pre-start && stencil build --dev",
	start: "npm run pre-start && stencil build --dev --watch --serve",
	"start:dev": "npm run pre-start && stencil build --dev --watch --serve",
	"start:watch": "npm run pre-start && stencil build --dev --watch",
	"start:watch:prod": "cross-env NODE_ENV=production npm run pre-start && stencil build --watch",
	startPrerender: "npm run pre-start && stencil build --prerender",
	test: "npm run pre-start && stencil test --spec --e2e",
	"test:unit": "npm run pre-start && stencil test --spec",
	"test:unit:coverage": "npm run pre-start && stencil test --spec --coverage",
	"test:unit:watch": "npm run pre-start && stencil test --spec --watchAll",
	"test:e2e": "npm run pre-start && stencil test --e2e",
	"test:e2e:watch": "npm run pre-start && stencil test --e2e --watchAll",
	"test:watch": "npm run pre-start && stencil test --spec --e2e --watchAll",
	lint: "eslint src/components/**/*.{ts,tsx,js}",
	"lint:fix": "eslint --fix src/components/**/*.{ts,tsx,js}",
	storybook: "start-storybook -s ./www -p 6006",
	"storybook:build": "build-storybook -o ./www/storybook",
	"tsc-check": "tsc --noEmit",
	"fix-readme": "node fix-readme.js",
	postshrinkwrap: "npx --quiet npm-force-resolutions && npm install --no-package-lock --no-audit --no-fund --no-progress --silent",
	"pre-start": "node pre-start.js",
	"local-server": "cd dist && npx serve -p 50356 --cors",
	release: "commit-and-tag-version"
};
const devDependencies = {
	"@babel/core": "^7.16.5",
	"@pxblue/storybook-rtl-addon": "^1.1.0",
	"@se/postcss-host-polyfill": "^2.0.0",
	"@stencil/postcss": "^2.1.0",
	"@stencil/react-output-target": "0.2.0",
	"@stencil/sass": "^1.5.2",
	"@stencil/store": "^1.5.0",
	"@storybook/addon-actions": "^6.4.9",
	"@storybook/addon-info": "^5.3.21",
	"@storybook/addon-knobs": "^6.2.9",
	"@storybook/addon-notes": "^5.3.21",
	"@storybook/addon-viewport": "^6.4.9",
	"@storybook/addons": "^6.4.9",
	"@storybook/builder-webpack5": "^6.4.9",
	"@storybook/core-events": "^6.4.9",
	"@storybook/html": "^6.4.9",
	"@storybook/manager-webpack5": "^6.4.9",
	"@types/autoprefixer": "^10.2.0",
	"@types/classnames": "^2.3.0",
	"@types/hammerjs": "^2.0.41",
	"@types/jest": "^27.0.3",
	"@types/lodash": "^4.14.178",
	"@types/puppeteer": "^5.4.4",
	"@types/youtube": "0.0.47",
	"@typescript-eslint/eslint-plugin": "^5.6.0",
	"@typescript-eslint/parser": "^5.6.0",
	autoprefixer: "^10.4.0",
	"babel-loader": "^8.2.3",
	"commit-and-tag-version": "^12.0.0",
	"copy-webpack-plugin": "^10.2.0",
	"cross-env": "^7.0.3",
	eslint: "^8.56.0",
	"eslint-config-airbnb-base": "^15.0.0",
	"eslint-config-airbnb-typescript": "^17.1.0",
	"eslint-plugin-import": "^2.29.1",
	"eslint-plugin-jest": "^27.6.0",
	"eslint-plugin-jest-formatting": "^3.1.0",
	"eslint-plugin-storybook": "^0.6.15",
	"fetch-mock": "^9.11.0",
	jest: "^26.6.3",
	"jest-cli": "^26.6.3",
	"postcss-rtlcss": "^3.5.1",
	puppeteer: "^10.4.0",
	rimraf: "^3.0.2",
	"rollup-plugin-node-polyfills": "0.2.1",
	"rollup-plugin-visualizer": "^5.5.2",
	"stencil-inline-svg": "^1.1.0",
	typescript: "^4.5.4",
	"write-file-webpack-plugin": "^4.5.1"
};
const license = "MIT";
const dependencies = {
	"@juggle/resize-observer": "^3.3.1",
	"@pes-ui/styles": "3.80.0",
	"@pes-ui/utils": "3.88.3",
	"@popperjs/core": "^2.11.0",
	"@se/icons": "4.9.7",
	"@se/web-ui": "3.28.4",
	"@stencil/core": "2.12.0",
	"@types/sanitize-html": "2.6.2",
	classnames: "^2.3.1",
	clipboard: "^2.0.8",
	"event-source-polyfill": "^1.0.25",
	fontfaceobserver: "^2.1.0",
	hammerjs: "^2.0.8",
	lodash: "^4.17.21",
	normalizr: "^3.6.1",
	"path-browserify": "^1.0.1",
	"query-string": "^7.0.1",
	"sanitize-html": "2.7.3",
	"smoothscroll-polyfill": "^0.4.4",
	swiper: "^6.8.4",
	url: "^0.11.0"
};
const resolutions = {
	lodash: "4.17.21",
	prismjs: "^1.23.0",
	"node-fetch": "^2.6.1",
	marked: "0.8.2"
};
const engines = {
	node: "^14.17.6",
	npm: "^6.14.15"
};
const packageJson = {
	name: name,
	version: version,
	description: description,
	main: main,
	module: module,
	es2015: es2015,
	es2017: es2017,
	types: types,
	collection: collection,
	"collection:main": "dist/collection/index.js",
	unpkg: unpkg,
	files: files,
	scripts: scripts,
	devDependencies: devDependencies,
	license: license,
	dependencies: dependencies,
	resolutions: resolutions,
	engines: engines
};

const list = [
  { country: 'WW', language: ['en'] },
  { country: 'AE', language: ['en'] },
  { country: 'AR', language: ['es'] },
  { country: 'AT', language: ['de'] },
  { country: 'AU', language: ['en'] },
  { country: 'BE', language: ['fr', 'nl'] },
  { country: 'BG', language: ['bg'] },
  { country: 'BR', language: ['pt'] },
  { country: 'CA', language: ['en', 'fr'] },
  { country: 'CH', language: ['fr', 'de'] },
  { country: 'CL', language: ['es'] },
  { country: 'CN', language: ['zh'] },
  { country: 'CO', language: ['es'] },
  { country: 'CR', language: ['es'] },
  { country: 'CZ', language: ['cs'] },
  { country: 'DE', language: ['de'] },
  { country: 'DK', language: ['da'] },
  { country: 'DZ', language: ['fr'] },
  { country: 'EE', language: ['et'] },
  { country: 'EG', language: ['en', 'ar'] },
  { country: 'ES', language: ['es'] },
  { country: 'FI', language: ['fi'] },
  { country: 'FR', language: ['fr'] },
  { country: 'GR', language: ['el'] },
  { country: 'HK', language: ['en'] },
  { country: 'HR', language: ['hr'] },
  { country: 'HU', language: ['hu'] },
  { country: 'ID', language: ['en', 'id'] },
  { country: 'IE', language: ['en'] },
  { country: 'IL', language: ['en'] },
  { country: 'IN', language: ['en'] },
  { country: 'IT', language: ['it'] },
  { country: 'JP', language: ['ja'] },
  { country: 'KR', language: ['ko'] },
  { country: 'KZ', language: ['ru'] },
  { country: 'LT', language: ['lt'] },
  { country: 'LV', language: ['lv'] },
  { country: 'MA', language: ['fr'] },
  { country: 'MY', language: ['en'] },
  { country: 'NG', language: ['en'] },
  { country: 'NL', language: ['nl'] },
  { country: 'NO', language: ['no'] },
  { country: 'NZ', language: ['en'] },
  { country: 'PE', language: ['es'] },
  { country: 'PH', language: ['en'] },
  { country: 'PL', language: ['pl'] },
  { country: 'PT', language: ['pt'] },
  { country: 'RO', language: ['ro'] },
  { country: 'RS', language: ['sr'] },
  { country: 'RU', language: ['ru'] },
  { country: 'SA', language: ['en'] },
  { country: 'SE', language: ['sv'] },
  { country: 'SG', language: ['en'] },
  { country: 'SI', language: ['sl'] },
  { country: 'SK', language: ['sk'] },
  { country: 'TH', language: ['th', 'en'] },
  { country: 'TR', language: ['tr'] },
  { country: 'TW', language: ['zh'] },
  { country: 'UA', language: ['uk', 'ru'] },
  { country: 'UK', language: ['en'] },
  { country: 'US', language: ['en'] },
  { country: 'VN', language: ['vi', 'en'] },
  { country: 'ZA', language: ['en'] },
  { country: 'MX', language: ['es'] },
];

function isNullOrUndefined(value) {
  return typeof value === 'undefined' || value === null;
}
function getDefaultCountry(isUpperCase) {
  const defaultCountry = list[0].country;
  return isUpperCase ? defaultCountry.toUpperCase() : defaultCountry.toLowerCase();
}
function getExistOrDefaultLanguage(language) {
  const languages = list[0].language;
  return languages.includes(language) ? language : languages[0];
}
const validate = (country, language) => {
  const result = { country, language };
  const COUNTRY = isNullOrUndefined(country) ? 'NO COUNTRY' : country.toUpperCase();
  const countryLanguages = list.find((countryLanguage) => countryLanguage.country === COUNTRY);
  if (countryLanguages) {
    if (!countryLanguages.language.includes(language)) {
      result.language = countryLanguages.language[0];
    }
  }
  else {
    result.country = getDefaultCountry(country === COUNTRY);
    result.language = getExistOrDefaultLanguage(language);
  }
  return result;
};

var punycode = createCommonjsModule(function (module, exports) {
(function(root) {

	/** Detect free variables */
	var freeExports = exports &&
		!exports.nodeType && exports;
	var freeModule = module &&
		!module.nodeType && module;
	var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.3.2',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (freeExports && freeModule) {
		if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else { // in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.punycode = punycode;
	}

}(commonjsGlobal));
});

var util = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};

// Copyright Joyent, Inc. and other Node contributors.

// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var decode = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (Array.isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

// Copyright Joyent, Inc. and other Node contributors.

var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

var encode = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return Object.keys(obj).map(function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (Array.isArray(obj[k])) {
        return obj[k].map(function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var querystring = createCommonjsModule(function (module, exports) {

exports.decode = exports.parse = decode;
exports.encode = exports.stringify = encode;
});

var parse = urlParse;
var resolve = urlResolve;
var resolveObject = urlResolveObject;
var format = urlFormat;

var Url_1 = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    };

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};

var url = {
	parse: parse,
	resolve: resolve,
	resolveObject: resolveObject,
	format: format,
	Url: Url_1
};

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

var isUndefined_1 = isUndefined;

/**
 * The base implementation of `_.nth` which doesn't coerce arguments.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {number} n The index of the element to return.
 * @returns {*} Returns the nth element of `array`.
 */
function baseNth(array, n) {
  var length = array.length;
  if (!length) {
    return;
  }
  n += n < 0 ? length : 0;
  return _isIndex(n, length) ? array[n] : undefined;
}

var _baseNth = baseNth;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber_1(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

var toFinite_1 = toFinite;

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite_1(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

var toInteger_1 = toInteger;

/**
 * Gets the element at index `n` of `array`. If `n` is negative, the nth
 * element from the end is returned.
 *
 * @static
 * @memberOf _
 * @since 4.11.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=0] The index of the element to return.
 * @returns {*} Returns the nth element of `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'd'];
 *
 * _.nth(array, 1);
 * // => 'b'
 *
 * _.nth(array, -2);
 * // => 'c';
 */
function nth(array, n) {
  return (array && array.length) ? _baseNth(array, toInteger_1(n)) : undefined;
}

var nth_1 = nth;

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/**
 * Helpers to enable Immutable compatibility *without* bringing in
 * the 'immutable' package as a dependency.
 */

/**
 * Check if an object is immutable by checking if it has a key specific
 * to the immutable library.
 *
 * @param  {any} object
 * @return {bool}
 */
function isImmutable(object) {
  return !!(object && typeof object.hasOwnProperty === 'function' && (object.hasOwnProperty('__ownerID') || // Immutable.Map
  object._map && object._map.hasOwnProperty('__ownerID'))); // Immutable.Record
}
/**
 * Denormalize an immutable entity.
 *
 * @param  {Schema} schema
 * @param  {Immutable.Map|Immutable.Record} input
 * @param  {function} unvisit
 * @param  {function} getDenormalizedEntity
 * @return {Immutable.Map|Immutable.Record}
 */

function denormalizeImmutable(schema, input, unvisit) {
  return Object.keys(schema).reduce(function (object, key) {
    // Immutable maps cast keys to strings on write so we need to ensure
    // we're accessing them using string keys.
    var stringKey = "" + key;

    if (object.has(stringKey)) {
      return object.set(stringKey, unvisit(object.get(stringKey), schema[stringKey]));
    } else {
      return object;
    }
  }, input);
}

var getDefaultGetId = function getDefaultGetId(idAttribute) {
  return function (input) {
    return isImmutable(input) ? input.get(idAttribute) : input[idAttribute];
  };
};

var EntitySchema = /*#__PURE__*/function () {
  function EntitySchema(key, definition, options) {
    if (definition === void 0) {
      definition = {};
    }

    if (options === void 0) {
      options = {};
    }

    if (!key || typeof key !== 'string') {
      throw new Error("Expected a string key for Entity, but found " + key + ".");
    }

    var _options = options,
        _options$idAttribute = _options.idAttribute,
        idAttribute = _options$idAttribute === void 0 ? 'id' : _options$idAttribute,
        _options$mergeStrateg = _options.mergeStrategy,
        mergeStrategy = _options$mergeStrateg === void 0 ? function (entityA, entityB) {
      return _extends({}, entityA, entityB);
    } : _options$mergeStrateg,
        _options$processStrat = _options.processStrategy,
        processStrategy = _options$processStrat === void 0 ? function (input) {
      return _extends({}, input);
    } : _options$processStrat,
        _options$fallbackStra = _options.fallbackStrategy,
        fallbackStrategy = _options$fallbackStra === void 0 ? function (key, schema) {
      return undefined;
    } : _options$fallbackStra;
    this._key = key;
    this._getId = typeof idAttribute === 'function' ? idAttribute : getDefaultGetId(idAttribute);
    this._idAttribute = idAttribute;
    this._mergeStrategy = mergeStrategy;
    this._processStrategy = processStrategy;
    this._fallbackStrategy = fallbackStrategy;
    this.define(definition);
  }

  var _proto = EntitySchema.prototype;

  _proto.define = function define(definition) {
    this.schema = Object.keys(definition).reduce(function (entitySchema, key) {
      var _extends2;

      var schema = definition[key];
      return _extends({}, entitySchema, (_extends2 = {}, _extends2[key] = schema, _extends2));
    }, this.schema || {});
  };

  _proto.getId = function getId(input, parent, key) {
    return this._getId(input, parent, key);
  };

  _proto.merge = function merge(entityA, entityB) {
    return this._mergeStrategy(entityA, entityB);
  };

  _proto.fallback = function fallback(id, schema) {
    return this._fallbackStrategy(id, schema);
  };

  _proto.normalize = function normalize(input, parent, key, visit, addEntity, visitedEntities) {
    var _this = this;

    var id = this.getId(input, parent, key);
    var entityType = this.key;

    if (!(entityType in visitedEntities)) {
      visitedEntities[entityType] = {};
    }

    if (!(id in visitedEntities[entityType])) {
      visitedEntities[entityType][id] = [];
    }

    if (visitedEntities[entityType][id].some(function (entity) {
      return entity === input;
    })) {
      return id;
    }

    visitedEntities[entityType][id].push(input);

    var processedEntity = this._processStrategy(input, parent, key);

    Object.keys(this.schema).forEach(function (key) {
      if (processedEntity.hasOwnProperty(key) && typeof processedEntity[key] === 'object') {
        var schema = _this.schema[key];
        var resolvedSchema = typeof schema === 'function' ? schema(input) : schema;
        processedEntity[key] = visit(processedEntity[key], processedEntity, key, resolvedSchema, addEntity, visitedEntities);
      }
    });
    addEntity(this, processedEntity, input, parent, key);
    return id;
  };

  _proto.denormalize = function denormalize(entity, unvisit) {
    var _this2 = this;

    if (isImmutable(entity)) {
      return denormalizeImmutable(this.schema, entity, unvisit);
    }

    Object.keys(this.schema).forEach(function (key) {
      if (entity.hasOwnProperty(key)) {
        var schema = _this2.schema[key];
        entity[key] = unvisit(entity[key], schema);
      }
    });
    return entity;
  };

  _createClass(EntitySchema, [{
    key: "key",
    get: function get() {
      return this._key;
    }
  }, {
    key: "idAttribute",
    get: function get() {
      return this._idAttribute;
    }
  }]);

  return EntitySchema;
}();

var PolymorphicSchema = /*#__PURE__*/function () {
  function PolymorphicSchema(definition, schemaAttribute) {
    if (schemaAttribute) {
      this._schemaAttribute = typeof schemaAttribute === 'string' ? function (input) {
        return input[schemaAttribute];
      } : schemaAttribute;
    }

    this.define(definition);
  }

  var _proto = PolymorphicSchema.prototype;

  _proto.define = function define(definition) {
    this.schema = definition;
  };

  _proto.getSchemaAttribute = function getSchemaAttribute(input, parent, key) {
    return !this.isSingleSchema && this._schemaAttribute(input, parent, key);
  };

  _proto.inferSchema = function inferSchema(input, parent, key) {
    if (this.isSingleSchema) {
      return this.schema;
    }

    var attr = this.getSchemaAttribute(input, parent, key);
    return this.schema[attr];
  };

  _proto.normalizeValue = function normalizeValue(value, parent, key, visit, addEntity, visitedEntities) {
    var schema = this.inferSchema(value, parent, key);

    if (!schema) {
      return value;
    }

    var normalizedValue = visit(value, parent, key, schema, addEntity, visitedEntities);
    return this.isSingleSchema || normalizedValue === undefined || normalizedValue === null ? normalizedValue : {
      id: normalizedValue,
      schema: this.getSchemaAttribute(value, parent, key)
    };
  };

  _proto.denormalizeValue = function denormalizeValue(value, unvisit) {
    var schemaKey = isImmutable(value) ? value.get('schema') : value.schema;

    if (!this.isSingleSchema && !schemaKey) {
      return value;
    }

    var id = this.isSingleSchema ? undefined : isImmutable(value) ? value.get('id') : value.id;
    var schema = this.isSingleSchema ? this.schema : this.schema[schemaKey];
    return unvisit(id || value, schema);
  };

  _createClass(PolymorphicSchema, [{
    key: "isSingleSchema",
    get: function get() {
      return !this._schemaAttribute;
    }
  }]);

  return PolymorphicSchema;
}();

var UnionSchema = /*#__PURE__*/function (_PolymorphicSchema) {
  _inheritsLoose(UnionSchema, _PolymorphicSchema);

  function UnionSchema(definition, schemaAttribute) {
    if (!schemaAttribute) {
      throw new Error('Expected option "schemaAttribute" not found on UnionSchema.');
    }

    return _PolymorphicSchema.call(this, definition, schemaAttribute) || this;
  }

  var _proto = UnionSchema.prototype;

  _proto.normalize = function normalize(input, parent, key, visit, addEntity, visitedEntities) {
    return this.normalizeValue(input, parent, key, visit, addEntity, visitedEntities);
  };

  _proto.denormalize = function denormalize(input, unvisit) {
    return this.denormalizeValue(input, unvisit);
  };

  return UnionSchema;
}(PolymorphicSchema);

var ValuesSchema = /*#__PURE__*/function (_PolymorphicSchema) {
  _inheritsLoose(ValuesSchema, _PolymorphicSchema);

  function ValuesSchema() {
    return _PolymorphicSchema.apply(this, arguments) || this;
  }

  var _proto = ValuesSchema.prototype;

  _proto.normalize = function normalize(input, parent, key, visit, addEntity, visitedEntities) {
    var _this = this;

    return Object.keys(input).reduce(function (output, key, index) {
      var _extends2;

      var value = input[key];
      return value !== undefined && value !== null ? _extends({}, output, (_extends2 = {}, _extends2[key] = _this.normalizeValue(value, input, key, visit, addEntity, visitedEntities), _extends2)) : output;
    }, {});
  };

  _proto.denormalize = function denormalize(input, unvisit) {
    var _this2 = this;

    return Object.keys(input).reduce(function (output, key) {
      var _extends3;

      var entityOrId = input[key];
      return _extends({}, output, (_extends3 = {}, _extends3[key] = _this2.denormalizeValue(entityOrId, unvisit), _extends3));
    }, {});
  };

  return ValuesSchema;
}(PolymorphicSchema);

var validateSchema = function validateSchema(definition) {
  var isArray = Array.isArray(definition);

  if (isArray && definition.length > 1) {
    throw new Error("Expected schema definition to be a single schema, but found " + definition.length + ".");
  }

  return definition[0];
};

var getValues = function getValues(input) {
  return Array.isArray(input) ? input : Object.keys(input).map(function (key) {
    return input[key];
  });
};

var normalize = function normalize(schema, input, parent, key, visit, addEntity, visitedEntities) {
  schema = validateSchema(schema);
  var values = getValues(input); // Special case: Arrays pass *their* parent on to their children, since there
  // is not any special information that can be gathered from themselves directly

  return values.map(function (value, index) {
    return visit(value, parent, key, schema, addEntity, visitedEntities);
  });
};

var ArraySchema = /*#__PURE__*/function (_PolymorphicSchema) {
  _inheritsLoose(ArraySchema, _PolymorphicSchema);

  function ArraySchema() {
    return _PolymorphicSchema.apply(this, arguments) || this;
  }

  var _proto = ArraySchema.prototype;

  _proto.normalize = function normalize(input, parent, key, visit, addEntity, visitedEntities) {
    var _this = this;

    var values = getValues(input);
    return values.map(function (value, index) {
      return _this.normalizeValue(value, parent, key, visit, addEntity, visitedEntities);
    }).filter(function (value) {
      return value !== undefined && value !== null;
    });
  };

  _proto.denormalize = function denormalize(input, unvisit) {
    var _this2 = this;

    return input && input.map ? input.map(function (value) {
      return _this2.denormalizeValue(value, unvisit);
    }) : input;
  };

  return ArraySchema;
}(PolymorphicSchema);

var _normalize = function normalize(schema, input, parent, key, visit, addEntity, visitedEntities) {
  var object = _extends({}, input);

  Object.keys(schema).forEach(function (key) {
    var localSchema = schema[key];
    var resolvedLocalSchema = typeof localSchema === 'function' ? localSchema(input) : localSchema;
    var value = visit(input[key], input, key, resolvedLocalSchema, addEntity, visitedEntities);

    if (value === undefined || value === null) {
      delete object[key];
    } else {
      object[key] = value;
    }
  });
  return object;
};

var _denormalize = function denormalize(schema, input, unvisit) {
  if (isImmutable(input)) {
    return denormalizeImmutable(schema, input, unvisit);
  }

  var object = _extends({}, input);

  Object.keys(schema).forEach(function (key) {
    if (object[key] != null) {
      object[key] = unvisit(object[key], schema[key]);
    }
  });
  return object;
};

var ObjectSchema = /*#__PURE__*/function () {
  function ObjectSchema(definition) {
    this.define(definition);
  }

  var _proto = ObjectSchema.prototype;

  _proto.define = function define(definition) {
    this.schema = Object.keys(definition).reduce(function (entitySchema, key) {
      var _extends2;

      var schema = definition[key];
      return _extends({}, entitySchema, (_extends2 = {}, _extends2[key] = schema, _extends2));
    }, this.schema || {});
  };

  _proto.normalize = function normalize() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _normalize.apply(void 0, [this.schema].concat(args));
  };

  _proto.denormalize = function denormalize() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _denormalize.apply(void 0, [this.schema].concat(args));
  };

  return ObjectSchema;
}();

var visit = function visit(value, parent, key, schema, addEntity, visitedEntities) {
  if (typeof value !== 'object' || !value) {
    return value;
  }

  if (typeof schema === 'object' && (!schema.normalize || typeof schema.normalize !== 'function')) {
    var method = Array.isArray(schema) ? normalize : _normalize;
    return method(schema, value, parent, key, visit, addEntity, visitedEntities);
  }

  return schema.normalize(value, parent, key, visit, addEntity, visitedEntities);
};

var addEntities = function addEntities(entities) {
  return function (schema, processedEntity, value, parent, key) {
    var schemaKey = schema.key;
    var id = schema.getId(value, parent, key);

    if (!(schemaKey in entities)) {
      entities[schemaKey] = {};
    }

    var existingEntity = entities[schemaKey][id];

    if (existingEntity) {
      entities[schemaKey][id] = schema.merge(existingEntity, processedEntity);
    } else {
      entities[schemaKey][id] = processedEntity;
    }
  };
};

var schema = {
  Array: ArraySchema,
  Entity: EntitySchema,
  Object: ObjectSchema,
  Union: UnionSchema,
  Values: ValuesSchema
};
var normalize$1 = function normalize(input, schema) {
  if (!input || typeof input !== 'object') {
    throw new Error("Unexpected input given to normalize. Expected type to be \"object\", found \"" + (input === null ? 'null' : typeof input) + "\".");
  }

  var entities = {};
  var addEntity = addEntities(entities);
  var visitedEntities = {};
  var result = visit(input, input, null, schema, addEntity, visitedEntities);
  return {
    entities: entities,
    result: result
  };
};

const filter = new schema.Entity('filter', {}, {
  idAttribute: (value) => {
    const { navigationState, filterName } = value;
    return `${filterName}_${navigationState}`;
  },
  processStrategy: (value, parent) => {
    const { checked, count, disabled, label, filterName, navigationState, seoUrl, checkedURL, unCheckedURL, } = value;
    const { rootSectionId, parentCategoryId, nativeFilterCategory } = parent;
    return {
      label,
      value: `${filterName}_${navigationState}`,
      navigationState,
      seoUrl,
      count,
      isChecked: checked,
      isDisabled: disabled,
      rootSectionId,
      parentCategoryId,
      nativeFilterCategory,
      checkedURL,
      unCheckedURL,
    };
  },
});
const section = new schema.Entity('section', {
  filters: [filter],
}, {
  idAttribute: (value) => {
    const { filterCategory, filterSubCategory } = value;
    return filterSubCategory || filterCategory;
  },
  processStrategy: (value, parent) => {
    const { characteristicName, filterRefinements, subcharacteristics, filterCategory, filterSubCategory, nativeFilterCategory, } = value;
    const isMulti = value.filterRefinements.every((refinement) => typeof refinement.count === 'number');
    const { filterCategory: rootFilterCategory } = parent;
    return {
      name: characteristicName,
      isCollapsible: true,
      filters: filterRefinements,
      sections: subcharacteristics,
      rootSectionId: rootFilterCategory !== null && rootFilterCategory !== void 0 ? rootFilterCategory : filterCategory,
      parentCategoryId: filterSubCategory,
      nativeFilterCategory,
      type: isMulti ? 'multi' : 'single',
    };
  },
});
section.define({ sections: [section] });
const filters = [section];
const normalizeFilters = (rawData) => {
  return normalize$1(rawData, filters);
};
const clearNormalizedFilterData = (rawData) => {
  const { result, entities: { filter, section }, } = rawData;
  if (!filter || !section) {
    return null;
  }
  return {
    entities: {
      filter: Object.entries(filter).reduce((result, [key, value]) => {
        const newValue = Object.assign({}, value);
        ['parentCategoryId', 'navigationState'].forEach((keyToDelete) => {
          delete newValue[keyToDelete];
        });
        result[key] = newValue;
        return result;
      }, {}),
      section: Object.entries(section).reduce((result, [key, value]) => {
        const newValue = Object.assign({}, value);
        delete newValue.parentCategoryId;
        result[key] = newValue;
        return result;
      }, {}),
    },
    result,
  };
};
const changeCategoriesFields = (parentFilterCategory, subcharacteristicsArray) => {
  return subcharacteristicsArray.forEach((item) => {
    item.nativeFilterCategory = item.filterCategory;
    item.filterCategory = parentFilterCategory;
    item.filterSubCategory = `${item.nativeFilterCategory}_${item.filterSubCategory}`;
    if (item.subcharacteristics.length > 0) {
      changeCategoriesFields(parentFilterCategory, item.subcharacteristics);
    }
  });
};
const trackFilterAnalytics = (e, filtersNormalized) => {
  const { refinementId } = e.detail;
  const { value, nativeFilterCategory, parentCategoryId, rootSectionId, navigationState } = filtersNormalized.entities.filter[refinementId];
  const nativeParentCategoryId = parentCategoryId.slice(`${nativeFilterCategory}_`.length, parentCategoryId.length);
  const filterCategory = nativeFilterCategory || rootSectionId;
  const extraParams = {
    filterCategory,
    filterSubCategory: filterCategory !== nativeParentCategoryId ? nativeParentCategoryId : undefined,
    filterName: value.slice(0, value.indexOf(`_${navigationState}`)),
  };
  processGlobalAnalyticsEvent(e, extraParams);
};
function getCategories$1(filters) {
  var _a, _b;
  const categories = (_b = (_a = filters === null || filters === void 0 ? void 0 : filters[0]) === null || _a === void 0 ? void 0 : _a.filterRefinements) !== null && _b !== void 0 ? _b : [];
  return categories.map(({ checked, checkedURL, label }) => ({
    checked,
    navigationState: checkedURL,
    label,
  }));
}
async function fetchSprykerFilters(filtersUrl) {
  const response = await getData(false, filtersUrl);
  const { filters, pills, selectedFiltersQty } = response || {};
  let filtersNormalized;
  let filtrationSmartData;
  if (filters === null || filters === void 0 ? void 0 : filters.length) {
    filters.forEach((facet) => {
      facet.nativeFilterCategory = facet.filterCategory;
      changeCategoriesFields(facet.filterCategory, facet.subcharacteristics);
    });
    filtersNormalized = normalizeFilters(filters);
    filtrationSmartData = clearNormalizedFilterData(filtersNormalized);
  }
  const filtersCategories = getCategories$1(filters);
  return {
    filtersNormalized,
    filtrationSmartData,
    pills,
    filtersCategories,
    selectedSectionsCount: selectedFiltersQty,
    filters,
  };
}

function getPaginationParams(defaults) {
  const offset = Number(getQueryParam(OFFSET_PARAM_NAME, defaults.offset.toString()));
  const productsPerPage = Number(getQueryParam(PRODUCTS_PER_PAGE_PARAM_NAME, defaults.productsPerPage.toString()));
  return { offset, productsPerPage };
}
function setPaginationOffset(offset, pushToHistory = false) {
  const searchParams = new URLSearchParams(window.location.search);
  setQueryParam(searchParams, OFFSET_PARAM_NAME, offset.toString());
  if (pushToHistory) {
    window.history.pushState(null, '', `?${searchParams.toString()}${window.location.hash}`);
  }
  return searchParams;
}
function setPaginationParams(offset, Nrpp, pushToHistory = false) {
  const searchParams = new URLSearchParams(window.location.search);
  setQueryParam(searchParams, OFFSET_PARAM_NAME, offset.toString());
  setQueryParam(searchParams, PRODUCTS_PER_PAGE_PARAM_NAME, Nrpp.toString());
  if (pushToHistory) {
    window.history.pushState(null, '', `?${searchParams.toString()}${window.location.hash}`);
  }
  return searchParams;
}
function getCategories(filters) {
  var _a, _b;
  const categories = (_b = (_a = filters === null || filters === void 0 ? void 0 : filters[0]) === null || _a === void 0 ? void 0 : _a.filterRefinements) !== null && _b !== void 0 ? _b : [];
  return categories.map(({ checked, navigationState, label }) => ({
    checked,
    navigationState,
    label,
  }));
}
const getQueryObject = ({ filter, navState, pageParam, }) => {
  if (getNavigationState(navState) === '?') {
    return {};
  }
  const queryObj = {
    filter,
    n: getNavigationState(navState),
    pageParam,
  };
  const queryParams = Object.keys(queryObj)
    .filter((key) => Boolean(queryObj[key]))
    .reduce((acc, k) => (Object.assign(Object.assign({}, acc), { [k]: queryObj[k] })), {});
  return queryParams;
};
async function fetchFilters(pathname, params) {
  const query = getQueryObject(params);
  const filtersUrl = url.format({ pathname, query });
  const response = await getData(false, filtersUrl);
  const { filters, pills, selectedFiltersQty } = response || {};
  let filtersNormalized;
  let filtrationSmartData;
  if (filters === null || filters === void 0 ? void 0 : filters.length) {
    filters.forEach((facet) => {
      facet.nativeFilterCategory = facet.filterCategory;
      changeCategoriesFields(facet.filterCategory, facet.subcharacteristics);
    });
    filtersNormalized = normalizeFilters(filters);
    filtrationSmartData = clearNormalizedFilterData(filtersNormalized);
  }
  const filtersCategories = getCategories(filters);
  return {
    filtersNormalized,
    filtrationSmartData,
    pills,
    filtersCategories,
    selectedSectionsCount: selectedFiltersQty,
  };
}
async function fetchProducts(productsUrl, navState, offset, productsPerPage, filter) {
  const url = getProductsUrl(productsUrl, navState, offset, productsPerPage, filter);
  const response = await getData(false, url);
  const parsedProducts = parseRecords({ contents: [response] });
  return parsedProducts;
}
async function fetchRanges(pathname, navState, filter, params) {
  const paramsObject = {
    pathname,
    query: Object.assign({}, (filter && { filter })),
  };
  if (isV3()) {
    paramsObject.query.brand = params.brand;
    paramsObject.query['country-code'] = params.countryCode;
    paramsObject.query['language-code'] = params.languageCode;
  }
  if (navState !== '?') {
    paramsObject.query.n = getNavigationState(navState);
  }
  const rangesUrl = url.format(paramsObject);
  return getData(false, rangesUrl);
}
function mergePaginationConfig(productsInfo, existingPaginationConfig, { isDesktop }) {
  const { totalNumRecs, firstRecNum, lastRecNum, records } = productsInfo;
  const { firstLoadedRecNum, lastLoadedRecNum } = existingPaginationConfig;
  return {
    firstRecNum,
    lastRecNum,
    totalNumRecs,
    hasProducts: (records === null || records === void 0 ? void 0 : records.length) > 0,
    firstLoadedRecNum: isDesktop || firstLoadedRecNum === undefined
      ? firstRecNum
      : Math.min(firstRecNum, firstLoadedRecNum),
    lastLoadedRecNum: isDesktop || lastLoadedRecNum === undefined
      ? lastRecNum
      : Math.max(lastRecNum, lastLoadedRecNum),
  };
}
function getNavigationStateParam(defaultNavigationState = '') {
  return getNavigationState(getQueryParam(NAVIGATION_STATE_PARAM_NAME, defaultNavigationState));
}
function handleNavigationState(navState) {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.delete(OFFSET_PARAM_NAME);
  searchParams.delete(PRODUCTS_PER_PAGE_PARAM_NAME);
  setQueryParam(searchParams, NAVIGATION_STATE_PARAM_NAME, getNavigationState(navState));
  window.history.pushState(null, '', `?${searchParams.toString()}${window.location.hash}`);
}
const getNavState = (filter, filterId) => {
  var _a;
  const navStateFromFilter = (_a = filter[filterId]) === null || _a === void 0 ? void 0 : _a.navigationState;
  return new URLSearchParams(navStateFromFilter).get('n');
};

const MAX_VISIBLE_CARDS_WHILE_COLLAPSED = 3;
const MAX_RANGES_BEFORE_SDL_PROMO_BANNER = 2;
const listingTypes = {
  SUBCATEGORY_LISTING: 'subcategory listing',
  CATEGORY_LISTING: 'category listing',
};
const pageParam = {
  SUBCATEGORY_LISTING: 'subcategoryListing',
  CATEGORY_LISTING: 'categoryListing',
  RANGE_LISTING: 'rangeListing',
};
const DEFAULT_CATEGORY_PRODUCT_CTAS = Object.assign(Object.assign({}, productCtas), { buttons: {
    [productCtasButtonType.CART]: Object.assign({ isShown: false }, productCtas.buttons[productCtasButtonType.CART]),
    [productCtasButtonType.FAVORITES]: Object.assign({ isShown: false }, productCtas.buttons[productCtasButtonType.FAVORITES]),
  } });

const isDefined = (value) => {
  return !isUndefined_1(value);
};
const getArray = (value) => {
  if (isUndefined_1(value)) {
    return [];
  }
  return Array.isArray(value) ? value : [value];
};
const raf = (handler) => {
  if (typeof requestAnimationFrame === 'function') {
    return requestAnimationFrame(handler);
  }
  return setTimeout(handler);
};
const componentOnReady = (el, callback) => {
  if (el.componentOnReady) {
    el.componentOnReady().then(callback);
  }
  else {
    raf(callback);
  }
};
const asyncComponentOnReady = (element) => {
  return new Promise((resolve) => componentOnReady(element, resolve));
};
const html2plain = (html) => {
  const tempEl = document.createElement('div');
  tempEl.innerHTML = html;
  return tempEl.textContent || tempEl.innerText || '';
};
const getOffsetTop = (el) => {
  let offsetTop = 0;
  let currentElement = el;
  while (currentElement.offsetParent) {
    offsetTop += currentElement.offsetTop;
    currentElement = currentElement.offsetParent;
  }
  return offsetTop;
};
const scrollToTop = (el) => {
  var _a, _b;
  const headerHeight = (_b = (_a = document.querySelector('header')) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height) !== null && _b !== void 0 ? _b : 0;
  window.scrollTo({
    top: getOffsetTop(el) - headerHeight,
    behavior: 'smooth',
  });
};
const isBrowser = () => Build.isBrowser;
const createNewScripts = (scripts) => {
  const newScripts = [];
  scripts.forEach((script) => {
    const newScript = document.createElement('script');
    Array.from(script.attributes).forEach((attr) => {
      if (attr.nodeValue) {
        newScript.setAttribute(attr.nodeName, attr.nodeValue);
      }
    });
    newScripts.push(newScript);
    script.remove();
  });
  return newScripts;
};
const pasteScripts = (element, selector, parameters = {}) => {
  const { shadow = false } = parameters;
  let content;
  if (shadow) {
    content = element.shadowRoot.querySelector(selector);
  }
  else {
    content = element.querySelector(selector);
  }
  if (content) {
    const scripts = content.querySelectorAll('script');
    const newScripts = createNewScripts(scripts);
    newScripts.forEach((child) => {
      content.appendChild(child);
    });
  }
};
const getLocaleCodes = (localeCode) => {
  const matchArray = localeCode.match(LOCALE_CODE_REGEX);
  if (!matchArray) {
    return null;
  }
  const [, countryCode, languageCode] = matchArray;
  return {
    countryCode: countryCode === null || countryCode === void 0 ? void 0 : countryCode.toLowerCase(),
    languageCode: languageCode === null || languageCode === void 0 ? void 0 : languageCode.toLowerCase(),
  };
};
const getQueryParam = (paramName, defaultValue = '') => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.has(paramName) ? searchParams.get(paramName) : defaultValue;
};
const setQueryParam = (searchParams, paramName, value) => {
  if (value) {
    searchParams.set(paramName, value);
  }
  else {
    searchParams.delete(paramName);
  }
};
const getCountry = (localeCode) => { var _a; return (_a = nth_1(localeCode.split('/'), -2)) !== null && _a !== void 0 ? _a : ''; };
const getContextRoot = (localeCode) => nth_1(localeCode.split('/'), -3);
const getLanguage = (localeCode) => { var _a; return (_a = nth_1(localeCode.split('/'), -1)) !== null && _a !== void 0 ? _a : ''; };
const replacePlusWithSpace = (s) => s.replace(/\+/g, ' ');
const getNavigationState = (rawNavState) => {
  var _a;
  const navStateWithSpace = replacePlusWithSpace(rawNavState);
  const urlSearchParams = new URLSearchParams(navStateWithSpace);
  return navStateWithSpace.replace(/\+/g, ' ').search(/\=/) === -1
    ? navStateWithSpace
    : (_a = urlSearchParams.get(NAVIGATION_STATE_PARAM_NAME)) !== null && _a !== void 0 ? _a : urlSearchParams.get(NAVIGATION_STATE_PARAM_NAME.toLowerCase());
};
const getProductsUrl = (pathname, navState, offset, productsPerPage, filter) => {
  if (navState === '?') {
    return url.format({
      pathname,
      query: {
        No: offset,
        Nrpp: productsPerPage,
        format: 'json',
        filter,
      },
    });
  }
  return url.format({
    pathname,
    query: Object.assign(Object.assign({}, (navState.includes('subNodeId')
      ? { subNodeId: navState.replace('?subNodeId=', '') }
      : { N: getNavigationState(navState) })), { No: offset, Nrpp: productsPerPage, format: 'json', filter }),
  });
};
const openPopupCenter = ({ url, title, w = 1015, h = 680 }) => {
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
  const width = window.innerWidth
    ? window.innerWidth
    : document.documentElement.clientWidth
      ? document.documentElement.clientWidth
      : window.screen.width;
  const height = window.innerHeight
    ? window.innerHeight
    : document.documentElement.clientHeight
      ? document.documentElement.clientHeight
      : window.screen.height;
  const systemZoom = width / window.screen.availWidth;
  const left = (width - w) / 2 / systemZoom + dualScreenLeft;
  const top = (height - h) / 2 / systemZoom + dualScreenTop;
  const newWindow = window.open(url, title, `
      scrollbars=yes,
      width=${w / systemZoom},
      height=${h / systemZoom},
      top=${top},
      left=${left}
      `);
  if (window.focus)
    newWindow.focus();
};
const getSiteTypeByURL = (location) => {
  return document.location.href.startsWith(`${location}/${b2cSiteTypeURLPrefix}`)
    ? siteType.B2C
    : siteType.B2B;
};
const calcBundlePrice = (countryLanguageCode, productActivePrice, productActivePriceValue, bundleActivePriceValue, qty) => {
  if (!productActivePrice || !productActivePriceValue || !bundleActivePriceValue) {
    return null;
  }
  const currencyCode = productActivePrice.match(/\D$|^\D/);
  const finalPrice = (productActivePriceValue + bundleActivePriceValue * qty).toFixed(2);
  const formattedPrice = format$1(finalPrice, { locale: countryLanguageCode });
  if (currencyCode.index === 0) {
    return `${currencyCode}${formattedPrice}`;
  }
  return `${formattedPrice}${currencyCode}`;
};
const addParameterToLink = function (link, queryParams, hash) {
  if (!link)
    return;
  const urlParsed = url.parse(link, true);
  const formatedQueryParams = Object.keys(queryParams).reduce((acc, key) => {
    const queryParam = queryParams[key];
    if (queryParam) {
      let parsedQueryParam;
      if (typeof queryParam === 'string' && queryParam.search('=') !== -1) {
        parsedQueryParam = querystring.parse(queryParam);
      }
      else {
        parsedQueryParam = { [key]: queryParam };
      }
      return Object.assign(Object.assign({}, acc), parsedQueryParam);
    }
    return acc;
  }, {});
  const { query } = urlParsed, rest = __rest(urlParsed, ["query"]);
  return url.format(Object.assign(Object.assign({ query: Object.assign(Object.assign({}, query), formatedQueryParams) }, rest), { hash }));
};
const getBrandName = () => {
  if (window.isApc)
    return 'apc';
  if (window.isAsco)
    return 'ascopower';
  return 'se';
};
const getLocaleWithV3 = (locale, isPublic) => {
  if (isPublic)
    return locale;
  return `${locale}/v3`;
};
const filterQueryParams = () => {
  const filter = getQueryParam('filter') || '';
  if (filter !== '')
    return `&filter=${filter}`;
  return '';
};
const getSprykerBaseQueryParams = (host) => {
  const countryCode = getCountry(host);
  const languageCode = getLanguage(host);
  const contextRoot = getContextRoot(host);
  return { countryCode, languageCode, contextRoot };
};
const getSprykerBaseQueryParamString = (host) => {
  return `brand=${getBrandName()}&country-code=${getCountry(host)}&language-code=${getLanguage(host)}`;
};
const getCategoryOrSubCatFilterUrl = (baseFilterUriPath, localeCode, subCategoryListingParams, filter) => {
  const sprykerBaseQueryParamString = getSprykerBaseQueryParamString(localeCode);
  const searchParams = new URLSearchParams(window.location.search);
  const subCategoryListingQueryParams = subCategoryListingParams.pageParam === listingTypes.SUBCATEGORY_LISTING
    ? `&subcategory-id=${subCategoryListingParams.subCategoryId}&pageParam=${pageParam.SUBCATEGORY_LISTING}`
    : '';
  if (searchParams.has(NAVIGATION_STATE_PARAM_NAME))
    return `${baseFilterUriPath}?${searchParams.get(NAVIGATION_STATE_PARAM_NAME)}`;
  return `${baseFilterUriPath}?${sprykerBaseQueryParamString}${subCategoryListingQueryParams}&filter=${filter}`;
};
const filterReset = (CurrentCheckedUrl, baseFilterUrl) => {
  return CurrentCheckedUrl === baseFilterUrl;
};
const getBaseUrl = (baseUriPath, localeCode) => {
  const filter = getQueryParam('filter') || '';
  return filter !== ''
    ? `${baseUriPath}?${getSprykerBaseQueryParamString(localeCode)}&filter=${filter}`
    : `${baseUriPath}?${getSprykerBaseQueryParamString(localeCode)}`;
};
const getCategoryRangesFilterUrl = (baseRangesUriPath, localeCode, subCategoryListingParams) => {
  const sprykerBaseQueryParamString = getSprykerBaseQueryParamString(localeCode);
  const searchParams = new URLSearchParams(window.location.search);
  const subCategoryListingQueryParams = subCategoryListingParams.pageParam === listingTypes.SUBCATEGORY_LISTING
    ? `&subcategory-id=${subCategoryListingParams.subCategoryId}`
    : '';
  if (searchParams.has(NAVIGATION_STATE_PARAM_NAME))
    return `${baseRangesUriPath}?${searchParams.get(NAVIGATION_STATE_PARAM_NAME)}`;
  return `${baseRangesUriPath}?${sprykerBaseQueryParamString}${subCategoryListingQueryParams}${filterQueryParams()}`;
};
function navigationPush(searchParams, path = '') {
  if (searchParams.toString() !== '') {
    window.history.pushState({}, '', `${path}?${searchParams.toString()}${window.location.hash}`);
  }
  else {
    window.history.pushState({}, '', window.location.href.split('?')[0]);
  }
}
const getRangeFilterUrl = (filterNodeId, filtersUriPath, localeCode) => {
  const searchParams = new URLSearchParams(window.location.search);
  const sprykerBaseQueryParamString = getSprykerBaseQueryParamString(localeCode);
  if (filterNodeId && !searchParams.has(NAVIGATION_STATE_PARAM_NAME)) {
    return `${filtersUriPath}?${sprykerBaseQueryParamString}&hlnode-id=${filterNodeId}`;
  }
  return searchParams.has(NAVIGATION_STATE_PARAM_NAME)
    ? `${filtersUriPath}?${searchParams.get(NAVIGATION_STATE_PARAM_NAME)}`
    : `${filtersUriPath}?${sprykerBaseQueryParamString}`;
};
const getFilterProductsUrl = (baseProductsUriPath, numberOfProducts, localeCode, filterNodeId, subCategoryListingParams) => {
  const sprykerBaseQueryParamString = getSprykerBaseQueryParamString(localeCode);
  const subcategoryListingProductParms = subCategoryListingParams.pageParam === listingTypes.SUBCATEGORY_LISTING
    ? `&subcategory-id=${subCategoryListingParams.subCategoryId}`
    : '';
  const { offset, productsPerPage } = getPaginationParams({
    offset: 0,
    productsPerPage: Number(numberOfProducts),
  });
  const searchParams = new URLSearchParams(window.location.search);
  if (filterNodeId && !searchParams.get(NAVIGATION_STATE_PARAM_NAME)) {
    return `${baseProductsUriPath}?${sprykerBaseQueryParamString}&hlnode-id=${filterNodeId}&No=${offset}&Nrpp=${productsPerPage}`;
  }
  return !searchParams.get(NAVIGATION_STATE_PARAM_NAME)
    ? `${baseProductsUriPath}?${sprykerBaseQueryParamString}${subcategoryListingProductParms}${filterQueryParams()}&No=${offset}&Nrpp=${productsPerPage}`
    : `${baseProductsUriPath}?${searchParams.get(NAVIGATION_STATE_PARAM_NAME)}&No=${offset}&Nrpp=${productsPerPage}`;
};
function setNavigationFilterPath(changedFilterUrl, nodeId, isReset = false, seoUrl) {
  const searchParams = new URLSearchParams(window.location.search);
  const queryParamsOfFilterurl = changedFilterUrl.slice(changedFilterUrl.indexOf('?') + 1);
  if (isReset &&
    searchParams.has(NAVIGATION_STATE_PARAM_NAME) &&
    searchParams.has(SELECTED_NODE_ID)) {
    searchParams.delete(NAVIGATION_STATE_PARAM_NAME);
    searchParams.delete(SELECTED_NODE_ID);
  }
  else {
    searchParams.set(NAVIGATION_STATE_PARAM_NAME, queryParamsOfFilterurl);
    searchParams.set(SELECTED_NODE_ID, nodeId);
  }
  searchParams.delete(OFFSET_PARAM_NAME);
  searchParams.delete(PRODUCTS_PER_PAGE_PARAM_NAME);
  navigationPush(searchParams, seoUrl);
}
const parseRichText = (richText) => {
  return (richText === null || richText === void 0 ? void 0 : richText.map((text) => text.replace(/<p>|&nbsp;|&#160;|<\/p>/g, '').trim())) || [];
};
const getSelectedNodeIdFromUrl = (initialNodeId) => {
  const selectedNodeIdFromUrl = getQueryParam(SELECTED_NODE_ID);
  return selectedNodeIdFromUrl !== '' ? selectedNodeIdFromUrl : initialNodeId;
};
const getPbsFilterProductsUrl = ({ host, ProductsPath, CheckedFiltersUrl, pbsOffset, Nrpp, }) => {
  return `${host}${ProductsPath}?${CheckedFiltersUrl === null || CheckedFiltersUrl === void 0 ? void 0 : CheckedFiltersUrl.split('?')[1]}&No=${pbsOffset}&Nrpp=${Nrpp}`;
};
const getPbsRangesfiltersUrl = ({ host, rangesPath, CheckedFiltersUrl, }) => {
  return `${host}${rangesPath}?${CheckedFiltersUrl === null || CheckedFiltersUrl === void 0 ? void 0 : CheckedFiltersUrl.split('?')[1]}`;
};
const getCategoryIdFromName = (categoryName) => {
  const CategoryMatch = categoryName.match(/\d+/);
  return CategoryMatch ? CategoryMatch[0] : '';
};

window.pes = window.pes || {};
window.pes.validateCountryLanguage = validate;
const makeGetData = (packageName, packageVersion) => (data, rest, authorization) => {
  if (data) {
    return new Promise((resolve) => resolve(data));
  }
  const header = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'UIaaS-Component-Package': `${packageName}@${packageVersion}`,
  };
  if (authorization) {
    header.Autorization = authorization;
  }
  if (rest && isBrowser()) {
    return fetch(rest, {
      method: 'GET',
      mode: 'cors',
      headers: header,
    }).then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response.status;
    });
  }
  return new Promise((resolve) => resolve(null));
};
const getData = makeGetData(packageJson.name, packageJson.version);
const isEmpty = (object = {}) => Object.getOwnPropertyNames(object).length === 0;
function isMobile() {
  const desktopBreakpoint = 980;
  return window.innerWidth < desktopBreakpoint;
}
const parseJsonResponse = (resp) => resp.json();
const parseJSONString = (str, defaultValue) => {
  try {
    return JSON.parse(str);
  }
  catch (e) {
    return defaultValue;
  }
};
const isValidUrl = (url) => {
  try {
    new URL(url);
  }
  catch (_a) {
    return false;
  }
  return true;
};
const transformCamelCaseString = (string = '', delimeter = '') => {
  return string.replace(/([a-z0-9])([A-Z])/g, `$1${delimeter}$2`).toLowerCase();
};
const deepMerge = (target = {}, source) => {
  for (const key of Object.keys(source)) {
    if (Array.isArray(source[key])) {
      target[key] = [...source[key]];
    }
    else if (source[key] instanceof Object) {
      Object.assign(source[key], deepMerge(target[key], source[key]));
    }
  }
  Object.assign(target || {}, source);
  return target;
};
const getDataAttributes = (dataset) => {
  if (!dataset) {
    return {};
  }
  return Object.keys(dataset).reduce((acc, key) => {
    acc[`data-${transformCamelCaseString(key, '-')}`] = dataset[key];
    return acc;
  }, {});
};
const roundHalf = (num) => {
  return Math.round(num * 2) / 2;
};
const convertToPx = (...values) => {
  return values.map((val) => `${val}px`).join(' ');
};
const encodeProductId = (id) => encodeURIComponent(encodeURIComponent(id));
const isTargetBlank = (target) => target === '_blank';
const isLinkTypeOnline = (type) => type in ONLINE_CTA_TYPES;
const sendEvent = (type, data) => {
  const customEvent = new CustomEvent(type, {
    detail: data,
  });
  window.dispatchEvent(customEvent);
};
const getParamValueFromURL = (url, paramName) => {
  var _a;
  const regExp = new RegExp(`[?&](${paramName})=([^&]+).*$`);
  return (_a = url.match(regExp)) === null || _a === void 0 ? void 0 : _a[2];
};
const getYouTubeVideoIDFromURL = (youTubeURL) => {
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = youTubeURL.match(regExp);
  return match && match[7].length === 11 ? match[7] : '';
};
const urlDecode = (encodedString) => decodeURIComponent(encodedString.replace(/\+/g, ' '));

export { getLocaleWithV3 as $, version as A, getSprykerBaseQueryParams as B, asyncComponentOnReady as C, getArray as D, isDefined as E, html2plain as F, getLocaleCodes as G, getBrandName as H, scrollToTop as I, setQueryParam as J, getCategoryIdFromName as K, BUSINESS_ID_PARAM_NAME as L, getCountry as M, NAVIGATION_STATE_PARAM_NAME as N, getLanguage as O, processGlobalAnalyticsEvent as P, OFFSET_PARAM_NAME as Q, PRODUCTS_PER_PAGE_PARAM_NAME as R, getNavigationState as S, replacePlusWithSpace as T, changeCategoriesFields as U, normalizeFilters as V, clearNormalizedFilterData as W, getProductsUrl as X, url as Y, getRangeFilterUrl as Z, getSelectedNodeIdFromUrl as _, isMobile as a, filterReset as a0, setPaginationParams as a1, trackFilterAnalytics as a2, setNavigationFilterPath as a3, getPaginationParams as a4, fetchSprykerFilters as a5, getPbsFilterProductsUrl as a6, getFilterProductsUrl as a7, parseRichText as a8, getBaseUrl as a9, DEFAULT_NAVIGATION_STATE as aa, pageParam as ab, DEFAULT_CATEGORY_PRODUCT_CTAS as ac, setPaginationOffset as ad, getNavigationStateParam as ae, handleNavigationState as af, getNavState as ag, fetchFilters as ah, fetchProducts as ai, fetchRanges as aj, listingTypes as ak, MAX_RANGES_BEFORE_SDL_PROMO_BANNER as al, MAX_VISIBLE_CARDS_WHILE_COLLAPSED as am, mergePaginationConfig as an, ADDITIONAL_CTA_LINKS as ao, NUMBER_OF_BUTTONS_BEFORE as ap, MAX_CTA_LIMIT as aq, pasteScripts as ar, productCtasButtonType as as, productCtasColors as at, openPopupCenter as au, toInteger_1 as av, getCategoryOrSubCatFilterUrl as aw, getCategoryRangesFilterUrl as ax, getPbsRangesfiltersUrl as ay, querystring as az, parseJSONString as b, isValidUrl as c, deepMerge as d, getDataAttributes as e, convertToPx as f, getData as g, encodeProductId as h, isEmpty as i, isTargetBlank as j, isLinkTypeOnline as k, getParamValueFromURL as l, makeGetData as m, getYouTubeVideoIDFromURL as n, productCtas as o, parseJsonResponse as p, calcBundlePrice as q, roundHalf as r, sendEvent as s, transformCamelCaseString as t, urlDecode as u, addParameterToLink as v, getQueryParam as w, getSiteTypeByURL as x, isBrowser as y, name as z };
